module.exports = __webpack_public_path__ + "img/_18.aba405cd.png";